import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TotpEnrollmentService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useDeleteRemoveAuthenticatorDevice = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  void,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      return await handleRequest(
        TotpEnrollmentService.deleteApiIdentityApiTotpEnrollmentRemoveAuthenticatorDevice()
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message='Authenticator device removed successfully.' />
          );
          await queryClient.invalidateQueries('getIsAuthenticatorDeviceRegistered');
          await queryClient.invalidateQueries('getTotpEnrollmentQrCode');
          onClose && onClose();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useDeleteRemoveAuthenticatorDevice;
